import { sdkFactory as wixPlatformV1Wishlist_sdkFactory_wishlist } from './src/platform-v1-wishlist.frontend';
import { sdkFactory as wixStoresCatalogV1Collection_sdkFactory_collections } from './src/stores-catalog-v1-collection.frontend';
import { sdkFactory as wixStoresCatalogV1Product_sdkFactory_products } from './src/stores-catalog-v1-product.frontend';
import { sdkFactory as wixStoresV1AbandonedCart_sdkFactory_abandonedCarts } from './src/stores-v1-abandoned-cart.frontend';
import { sdkFactory as wixStoresV1SubscriptionOption_sdkFactory_subscriptionOptions } from './src/stores-v1-subscription-option.frontend';
import { sdkFactory as wixStoresV2Inventory_sdkFactory_inventory } from './src/stores-v2-inventory.frontend';
import { sdkFactory as wixStoresV2Orders_sdkFactory_orders } from './src/stores-v2-orders.frontend';
export function sdkFactory(args) {
    return {
        wishlist: wixPlatformV1Wishlist_sdkFactory_wishlist(args),
        collections: wixStoresCatalogV1Collection_sdkFactory_collections(args),
        products: wixStoresCatalogV1Product_sdkFactory_products(args),
        abandonedCarts: wixStoresV1AbandonedCart_sdkFactory_abandonedCarts(args),
        subscriptionOptions: wixStoresV1SubscriptionOption_sdkFactory_subscriptionOptions(args),
        inventory: wixStoresV2Inventory_sdkFactory_inventory(args),
        orders: wixStoresV2Orders_sdkFactory_orders(args),
    };
}
//# sourceMappingURL=index.frontend.js.map